import { render, staticRenderFns } from "./AppointmentsList.vue?vue&type=template&id=9161f0ee"
import script from "./AppointmentsList.vue?vue&type=script&lang=js"
export * from "./AppointmentsList.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsList.vue?vue&type=style&index=0&id=9161f0ee&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9161f0ee')) {
      api.createRecord('9161f0ee', component.options)
    } else {
      api.reload('9161f0ee', component.options)
    }
    module.hot.accept("./AppointmentsList.vue?vue&type=template&id=9161f0ee", function () {
      api.rerender('9161f0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Client/AppointmentsList.vue"
export default component.exports